import React, { useState, useEffect } from 'react';

const ItemWhModal = ({ formDetailList, showItemModal, handleItemClose, itemDataList, onRowSelectItem }) => {
    // สถานะการค้นหา
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredItemDataList, setFilteredItemDataList] = useState(itemDataList);
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (showItemModal) {
            setSearchTerm('');
        }
    }, [showItemModal]);

    useEffect(() => {
        const filteredList = itemDataList.filter(item => {
            const itemCode = item.Item_Code || '';
            const itemName = item.Item_Name || '';

            const matchesSearchTerm =
                itemCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
                itemName.toLowerCase().includes(searchTerm.toLowerCase());

            if (
                window.location.pathname === '/icebox' ||
                window.location.pathname === '/technical-equip-form' ||
                window.location.pathname === '/office-equip-form'
            ) {
                return matchesSearchTerm && item.Item_Onhand > 0;
            }

            return matchesSearchTerm;
        });

        setFilteredItemDataList(filteredList);
    }, [searchTerm, itemDataList]);


    useEffect(() => {
        if (showItemModal) {
            setSelectedItems(
                formDetailList.map((item) =>
                    itemDataList.find((filtered) => filtered.Item_Id === item.itemId)
                ).filter(Boolean)
            );
        }
    }, [showItemModal, formDetailList, itemDataList]);

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            setSelectedItems(filteredItemDataList);
        } else {
            setSelectedItems([]);
        }
    };

    const handleCheckboxChange = (item) => {
        const isSelected = selectedItems.some((selected) => selected.Item_Id === item.Item_Id);
        if (isSelected) {
            setSelectedItems((prevSelected) =>
                prevSelected.filter((selected) => selected.Item_Id !== item.Item_Id)
            );
        } else {
            setSelectedItems((prevSelected) => [...prevSelected, item]);
        }
    };

    return (
        <>
            <div
                className={`modal ${showItemModal ? 'show' : ''}`}
                style={{ display: showItemModal ? 'block' : 'none' }}
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อสินค้าในคลัง</h5>
                            <button type="button" className="close" onClick={handleItemClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="ค้นหา รหัสสินค้า หรือ ชื่อสินค้า"
                                    value={searchTerm || ''}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: "5%" }}>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                                    checked={
                                                        filteredItemDataList.length > 0 &&
                                                        selectedItems.length === filteredItemDataList.length
                                                    }
                                                />
                                            </th>
                                            <th className="text-center" style={{ width: '226px' }}>รหัสสินค้า</th>
                                            <th className="text-center" style={{ width: '529px' }}>ชื่อสินค้า</th>
                                            <th className="text-center" style={{ width: '529px' }}>สินค้าคงเหลือ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredItemDataList && filteredItemDataList.length > 0 ? (
                                            filteredItemDataList.map((item, index) => (
                                                <tr
                                                    key={item.Item_Id || index + 1}
                                                    onClick={() => handleCheckboxChange(item)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        backgroundColor: selectedItems.some(selectedItem => selectedItem.Item_Id === item.Item_Id)
                                                            ? 'rgb(105, 188, 216)'
                                                            : 'transparent',
                                                        transition: 'background-color 0.3s ease',
                                                    }}
                                                >
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedItems.some((selected) => selected.Item_Id === item.Item_Id)}
                                                            style={{
                                                                cursor: 'pointer',
                                                                backgroundColor: selectedItems.some(selected => selected.Item_Id === item.Item_Id)
                                                                    ? 'rgb(105, 188, 216)'
                                                                    : 'transparent',
                                                                transition: 'background-color 0.3s ease',
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="text-center">{item.Item_Code}</td>
                                                    <td className="text-left">{item.Item_Name}</td>
                                                    <td className="text-left">{item.Item_Onhand}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4">
                                                    <center>
                                                        <h5>ไม่พบข้อมูล</h5>
                                                    </center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary" onClick={() => onRowSelectItem(selectedItems)}
                            //disabled={selectedItems.length === 0} // คอมเม้นไว้ก่อน ใช้สำหรับ Disabled เมื่อยังไม่ได้เลือกสินค้า
                            >
                                ยืนยัน
                            </button>
                            <button className="btn btn-danger" onClick={handleItemClose}>
                                ปิด
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {showItemModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default ItemWhModal;